<h2>SLA Indiretos</h2>

<app-table
  [headers]="headers"
  [content]="filaList"
  [showFilter]="true"
  [hasEdit]="true"
  (editing)="edit($event)"
>
</app-table>
